module.exports = __webpack_public_path__ + "img/salasusu-logo.502eb1e3.png";